module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "box"
  }, [_vm._m(0), _vm._v(" "), _c('div', {
    staticClass: "box-body"
  }, [(_vm.testimonyLocation) ? _c('weather-card', {
    attrs: {
      "longitude": _vm.testimonyLocation.longitude,
      "latitude": _vm.testimonyLocation.latitude,
      "testimonyTime": _vm.testimonyTime
    }
  }) : _vm._e(), _vm._v(" "), _vm._l((_vm.tweets), function(tweet) {
    return _c('tweet', {
      key: tweet.id,
      attrs: {
        "id": tweet.id,
        "options": {
          cards: 'hidden'
        }
      }
    })
  })], 2)])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "box-header with-border"
  }, [_c('h3', {
    staticClass: "box-title"
  }, [_vm._v("Automatic additional data")])])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-2371f6f5"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/views/AutomaticData.vue
// module id = 431
// module chunks = 1